export const DRAG_DIRECTION_BEFORE = 'before';
export const DRAG_DIRECTION_AFTER = 'after';

export type DragDirection =
  | typeof DRAG_DIRECTION_BEFORE
  | typeof DRAG_DIRECTION_AFTER;
